// extracted by mini-css-extract-plugin
module.exports = {"portal-btn":"requestform_portal-btn__2v9y4","textmargin":"requestform_textmargin__1AT7N","textmargin__heading":"requestform_textmargin__heading__3Ddgr"};